import { GzSideMenuWebComponent } from '../../../ui/gzSideMenu';
import { EasmFindingDetailsWebComponent } from '../../easmFindingDetails';
import { ResizeDirection } from '../../../types/common/types';
import { EasmSideMenuEvents } from '../types';
import { FindingClassType, FindingType } from '../../types';
import { FindingGroup } from '../../findingDetails/findingDetails/types';
import { EasmRelatedFindingsWebComponent } from '../../easmRelatedFindings';
import { NotesListWebComponent } from '../../../notes/notesList';
import { NoteEvents } from '../../../notes/notesList/types';

export class GzEASMSideMenuWebComponent extends GzSideMenuWebComponent {
  private _shouldGridBeRefreshed = false;
  private dependencies: any;

  constructor() {
    super();

    this.addEventListener(EasmSideMenuEvents.OPEN_FINDING_DETAILS, this.handleOpenFindingDetails);
    this.addEventListener(EasmSideMenuEvents.OPEN_FINDING_RELATED, this.handleOpenFindingRelated);
    this.addEventListener(EasmSideMenuEvents.OPEN_NOTES, this.handleOpenNotes);
    this.addEventListener(EasmSideMenuEvents.CLOSE_SIDE_MENU, this.handleCloseSideMenu);
  }

  get shouldGridBeRefreshed(): boolean {
    const shouldGridBeRefreshed = this._shouldGridBeRefreshed;

    this._shouldGridBeRefreshed = false;

    return shouldGridBeRefreshed;
  }

  public injectDependencies(dependencies: any): void {
    this.dependencies = dependencies;
  }

  public setDetailsInContent(findingId: string): void {
    if (this.isOpen) {
      this.closeSideMenu(false);
    }

    const easmFindingDetailsWebComponent = new EasmFindingDetailsWebComponent();

    easmFindingDetailsWebComponent.findingId = findingId;

    easmFindingDetailsWebComponent.injectDependencies(this.dependencies);
    easmFindingDetailsWebComponent.start().then().catch();

    this.setMenuContent(easmFindingDetailsWebComponent);
    this.openSideMenu();
    this.closeOnClickOutside = true;
    this.resizable = ResizeDirection.LEFT;
  }

  public setRelatedInContent(
    findingId: string,
    findingClassType: FindingClassType,
    findingGroups: FindingGroup[],
    findingTypeGroupToFocusOn: FindingType | null
  ): void {
    if (this.isOpen) {
      this.closeSideMenu(false);
    }

    const easmRelatedFindingsWebComponent = new EasmRelatedFindingsWebComponent();

    easmRelatedFindingsWebComponent.findingId = findingId;
    easmRelatedFindingsWebComponent.findingClassType = findingClassType;
    easmRelatedFindingsWebComponent.findingGroups = findingGroups;
    easmRelatedFindingsWebComponent.findingGroupTypeToFocusOn = findingTypeGroupToFocusOn;

    easmRelatedFindingsWebComponent.injectDependencies(this.dependencies);
    easmRelatedFindingsWebComponent.start().then().catch();

    this.setMenuContent(easmRelatedFindingsWebComponent);
    this.openSideMenu();
    this.closeOnClickOutside = true;
    this.resizable = ResizeDirection.LEFT;
  }

  public setNotesInContent(findingId: string, isBackButtonEnabled: boolean = false): void {
    if (this.isOpen) {
      this.closeSideMenu(false);
    }

    const notesListWebComponent = new NotesListWebComponent();

    if (isBackButtonEnabled) {
      notesListWebComponent.addEventListener(NoteEvents.GO_BACK, (): void => this.setDetailsInContent(findingId));
    }

    const disableCloseOnClickOutside = (): void => {
        this.closeOnClickOutside = false;
      },
      enableCloseOnClickOutside = (): void => {
        this.closeOnClickOutside = true;
      },
      demandGridRefreshCallback = (): void => {
        this._shouldGridBeRefreshed = true;
      };

    notesListWebComponent.addEventListener(NoteEvents.CREATE_NOTE_CARD, disableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.CREATE_NOTE, enableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.CREATE_NOTE, demandGridRefreshCallback);
    notesListWebComponent.addEventListener(NoteEvents.EDIT_NOTE_CARD, disableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.EDIT_NOTE, enableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.DELETE_NOTE_CARD, disableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.DELETE_NOTE, enableCloseOnClickOutside);
    notesListWebComponent.addEventListener(NoteEvents.DELETE_NOTE, demandGridRefreshCallback);
    notesListWebComponent.addEventListener(NoteEvents.CLOSE_EDIT_WINDOW, enableCloseOnClickOutside);

    notesListWebComponent.injectDependencies({
      ...this.dependencies,
      api: { ...this.dependencies.api, modelName: 'EASMNotes' },
      isBackButtonEnabled,
      resourceId: findingId,
    });
    notesListWebComponent.start().then().catch();

    this.setMenuContent(notesListWebComponent);
    this.openSideMenu();
    this.closeOnClickOutside = true;
    this.resizable = ResizeDirection.LEFT;
  }

  private handleOpenFindingDetails(event: CustomEvent): void {
    this.setDetailsInContent(event.detail.findingId);
  }

  private handleOpenFindingRelated(event: CustomEvent): void {
    this.setRelatedInContent(
      event.detail.findingDetails._id,
      event.detail.classType,
      event.detail.classType === FindingClassType.ASSET
        ? event.detail.findingDetails.groupedByType.assets
        : event.detail.findingDetails.groupedByType.artifacts,
      event.detail.itemType ?? null
    );
  }

  private handleOpenNotes(event: CustomEvent): void {
    this.setNotesInContent(event.detail.findingId, event.detail.isBackButtonEnabled);
  }

  private handleCloseSideMenu(event: CustomEvent): void {
    if (event.detail.preventGridRefresh ?? false) {
      this._shouldGridBeRefreshed = false;
    }

    this.closeSideMenu();
  }
}
